// Group settings page temporarily under construction; staff management disabled.
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../../../components/under-construction';
import { terms } from '../../../language/terms';
@customElement('group-settings')
export class GroupSettings extends LitElement {
  render() {
    return html`<under-construction
      feature="${terms.loginGroup.value} ${terms.staffUser.value} Management"
    ></under-construction>`;
  }
}
